import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Placeholder from 'components/consumer/Placeholder';
import IconClose from 'components/icons/iconClose';
import { colorGrayLight1 } from 'styles/layout/colors';

const PDPDecideLaterPromoUI = ({
  heading,
  subheading,
  buttonText,
  loading = true,
  onButtonClick,
  onClose,
}) => (
  <Placeholder
    loading={loading}
    type="rect"
    className="!bg-yellow-light rounded min-h-[73px] max-[767px]:min-h-[122px]"
  >
    <div
      className={classNames(
        'items-center bg-yellow-light rounded text-gray-dark flex justify-between px-6 py-4 relative max-[767px]:items-start max-[767px]:flex-col',
        {
          'animate-fade-in-ease': loading === false,
        }
      )}
    >
      <div className="pr-4 max-[767px]:mb-4">
        <div className="text-base font-bold">{heading}</div>
        <div className="text-xs">{subheading}</div>
      </div>

      <div className="PDPDecideLaterPromoUI__button-wrapper">
        <button
          className="text-sm font-bold border-0 rounded-sm text-white px-3 py-2 hover:cursor-pointer hover:text-white max-[767px]:px-8 max-[767px]:py-[.7rem] bg-gray-dark"
          type="button"
          onClick={onButtonClick}
        >
          {buttonText}
        </button>
      </div>

      <button
        className="[background:none] border-0 px-2 py-[5px] absolute right-0 top-0 hover:cursor-pointer"
        type="button"
        onClick={onClose}
      >
        <IconClose color={colorGrayLight1} height={9} width={9} />
      </button>
    </div>
  </Placeholder>
);

PDPDecideLaterPromoUI.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  buttonText: PropTypes.string,
  loading: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onClose: PropTypes.func,
};

export default PDPDecideLaterPromoUI;
